import CommonModal from './CommonModal'
import ActionButton from './ActionButton'

import useCustomToast from '@/hooks/useCustomToast'

const ConfirmationModal = ({
  open,
  onOpenChange,
  heading,
  description,
  primaryButtonText,
  secondaryButtonText,
  primaryButtonAction,
  showSecondaryButton = true,
  loading,
}: any) => {
  const showToast = useCustomToast()

  return (
    <CommonModal
      open={open}
      title={heading}
      isHeader={true}
      isCloseButton={true}
      onOpenChange={onOpenChange}
    >
      <div>
        <h2 className="text-label-lg font-semibold text-gray-700 mb-6">
          {description}
        </h2>
        <div className="flex gap-4 items-center">
          {showSecondaryButton && (
            <ActionButton
              variant="secondary"
              title={secondaryButtonText || `No, Keep it`}
              className="text-label-lg font-semibold w-full"
              onClick={() => onOpenChange()}
              disabled={loading}
            />
          )}
          <ActionButton
            variant="primary"
            title={primaryButtonText || `Yes, Delete it`}
            loading={loading}
            disabled={loading}
            loadingText="Removing"
            className="text-label-lg font-semibold w-full"
            onClick={primaryButtonAction}
          />
        </div>
      </div>
    </CommonModal>
  )
}

export default ConfirmationModal
